import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ERROR } from '@/configs/constants';
import { ECOM_SEARCH_RESULT, ECOM_SEARCH_RESULT_PAGE, ECOM_SEARCH } from '@/configs/ecom/apis';
import { MapType } from '@/types';
import dlv from 'dlv';
import seoResponseTransform from '@/utils/seoResponseTransform';

export const getPopularDetail = async (): Promise<any> => {
  try {
    const response = await axiosInstance.post(generateBFFUrl(ECOM_SEARCH + '/popular'));
    return response.data;
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getSuggestDetail = async (q: string): Promise<any> => {
  try {
    const response = await axiosInstance.post(generateBFFUrl(ECOM_SEARCH + '/suggest'), {
      q,
    });
    return response.data;
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getSearchResultPage = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ECOM_SEARCH_RESULT_PAGE), {
      params: {
        'populate[seo][populate]': 'metaSocial.image,metaImage',
        'populate[layout][populate]':
          'products.media,products.tags,products.featuredTag,products.dealTag,list.ctas,features.image,content.ctas,content.desktopImage,content.mobileImage',
        populate: 'icon',
      },
    });
    const data = dlv(response, 'data.data.attributes', {});
    seoResponseTransform(data.seo);
    return data;
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const getSearchResults = async (body: MapType): Promise<any> => {
  try {
    const response = await axiosInstance.post(generateBFFUrl(ECOM_SEARCH_RESULT), body);
    return response.data;
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
